import { createStackNavigator } from '@react-navigation/stack';
import DatePicker from '_/space-management/screens/DatePicker';
import EditEvents from '_/space-management/screens/EditEvents';
import Home from '_/space-management/screens/Home';
import MyReservations from '_/space-management/screens/MyReservations';
import Notifications from '_/space-management/screens/Notifications';
import OnBoarding from '_/space-management/screens/OnBoarding';
import QRCodeScanner from '_/space-management/screens/QRCodeScanner';
import RecurringReservations from '_/space-management/screens/RecurringReservations';
import ReportAProblem from '_/space-management/screens/Reports/ReportAProblem';
import CreateReport from '_/space-management/screens/Reports/ReportAProblem/CreateReport';
import SetSlotCoordinate from '_/space-management/screens/SetSlotCoordinate';
import Workstation from '_/space-management/screens/Workstation';
import SlotScheduleScreen from '_/space-management/screens/SlotSchedule';
import React from 'react';

import { AppRoute } from './types';

const HomeStack = createStackNavigator();

export default function HomeStackScreen() {
  return (
    <HomeStack.Navigator
      screenOptions={{ animationEnabled: true, headerShown: false, presentation: 'card' }}
    >
      <HomeStack.Screen options={{ headerShown: false }} name={AppRoute.HOME} component={Home} />
      <HomeStack.Screen
        options={{ headerShown: false }}
        name={AppRoute.SLOT_SCHEDULE}
        component={SlotScheduleScreen}
      />
      <HomeStack.Screen
        options={{ headerShown: false }}
        name={AppRoute.MY_RESERVATIONS}
        component={MyReservations}
      />
      <HomeStack.Screen
        options={{ headerShown: false }}
        name={AppRoute.RECURRING_RESERVATIONS}
        component={RecurringReservations}
      />
      <HomeStack.Screen
        options={{ headerShown: false }}
        name={AppRoute.EDIT_EVENT}
        component={EditEvents}
      />
      <HomeStack.Screen
        options={{ headerShown: false }}
        name={AppRoute.DATE_PICKER}
        component={DatePicker}
      />
      <HomeStack.Screen
        options={{ headerShown: false }}
        name={AppRoute.WORK}
        component={Workstation}
      />
      <HomeStack.Screen
        options={{ headerShown: false }}
        name={AppRoute.QR_CODE_SCANNER}
        component={QRCodeScanner}
      />
      {/* <HomeStack.Screen
        options={{ headerShown: false }}
        name={AppRoute.NOTIFICATIONS}
        component={Notifications}
      />
      <HomeStack.Screen
        options={{ headerShown: false }}
        name={AppRoute.REPORT_PROBLEM}
        component={ReportAProblem}
      />
      <HomeStack.Screen
        options={{ headerShown: false }}
        name={AppRoute.CREATE_REPORT}
        component={CreateReport}
      /> */}
      <HomeStack.Screen
        options={{ headerBackTitleVisible: false, title: 'Select a slot below' }}
        name={AppRoute.SET_SLOT_COORDINATE}
        component={SetSlotCoordinate}
      />
    </HomeStack.Navigator>
  );
}
